import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import moment from 'moment';
import { downloadFile } from '@/api/manage';
export default {
  name: 'working',
  data: function data() {
    return {
      moment: moment,
      selectSearch: '',
      activeKey: '1',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      limitSelectDate: {},
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        width: '200px',
        title: '站点',
        align: 'center'
      },
      siteColumn2: {
        dataIndex: 'siteName',
        colName: 'site_id',
        width: '200px',
        title: '站点',
        align: 'center'
      },
      queryParam: {},
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      ipagination2: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      options: [],
      scroll: false,
      dataSource: [],
      columns: [],
      allColumns: [],
      selectCol: [],
      cols: [{
        title: '监测时间',
        align: 'center',
        width: 200,
        dataIndex: 'dataTime',
        colName: 'data_time'
      }],
      loading: false,
      options2: [],
      dataSource2: [],
      columns2: [],
      allColumns2: [],
      selectCol2: [],
      cols2: [{
        title: '监测时间',
        align: 'center',
        width: 200,
        dataIndex: 'dataTime',
        colName: 'data_time'
      }],
      loading2: false,
      searchData: []
    };
  },
  mixins: [GetSiteIdMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.queryParam.id = ids[1];
        this.queryParam.type = '1';

        if (this.activeKey == '1') {
          this.loadData();
        } else {
          this.getSearchData(ids[1]);
        }
      } //  else {
      //   this.queryParam.id = ids[1]
      //   this.queryParam.type = '2'
      //   if (this.activeKey == '1') {
      //     this.loadData()
      //   } else {
      //     this.getSearchData(ids[1])
      //   }
      // }

    }
  },
  created: function created() {
    this.queryParam.stime = moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.etime = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss');
  },
  methods: {
    onDateChange: function onDateChange(value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
      this.ipagination.current = 1;
      this.ipagination.pageSize = 10;
      this.ipagination2.current = 1;
      this.ipagination2.pageSize = 10;
      this.loadData();
      this.getSearchData();
    },
    handleExportXls: function handleExportXls(s) {
      downloadFile(s, "/st53/cn2011/export", this.queryParam);
    },
    onDateOk: function onDateOk(value) {
      console.log(value);
    },
    selectChange: function selectChange(e) {
      this.selectSearch = e.target.value;
      this.ipagination2.current = 1;
      this.ipagination2.pageSize = 10;
      this.loadData2(this.selectSearch);
    },
    callback: function callback(key) {
      console.log(key);
      this.activeKey = key; // this.queryParam.stime = moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
      // this.queryParam.etime = moment(moment().format('YYYY-MM-DD')+' 23:59:59').format('YYYY-MM-DD HH:mm:ss')

      if (key == '1') {
        this.loadData();
      } else {
        this.getSearchData();
      }
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      this.loadData();
    },
    handleTableChange2: function handleTableChange2(pagination, filters, sorter) {
      this.ipagination2 = pagination;
      this.loadData2(this.selectSearch);
    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function spliceColumn(col, idx) {
      var tempColumn = this.columns.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn;
        }
      }
    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn2: function spliceColumn2(col, idx) {
      var tempColumn = this.columns2.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns2.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns2.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns2.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns2 = tempColumn;
        }
      }
    },
    // 查询
    searchQuery: function searchQuery() {
      this.loadData();
    },
    // 列变化
    onChange: function onChange(checkedValues) {
      var _this = this;

      this.columns = _toConsumableArray(this.cols);
      checkedValues.forEach(function (item, i) {
        _this.allColumns.forEach(function (element) {
          if (item == element.id) {
            _this.columns.push(element);
          }
        });
      });
    },
    // 列变化
    onChange2: function onChange2(checkedValues) {
      var _this2 = this;

      this.columns2 = _toConsumableArray(this.cols2);
      checkedValues.forEach(function (item, i) {
        _this2.allColumns2.forEach(function (element) {
          if (item == element.id) {
            _this2.columns2.push(element);
          }
        });
      });
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    },
    // 水质标准
    renderStatus: function renderStatus(record) {
      var h = this.$createElement;

      if (record.currentStandard) {
        return h("span", {
          "class": "statusText",
          "style": 'background-color:' + record.currentStandard.color
        }, [record.currentStandard.title]);
      } else {
        return '';
      }
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;
      var data = record.dataMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value]);
      }
    },
    // 加载表格
    loadData: function loadData(arg) {
      var _this3 = this;

      this.loading = true;
      var that = this;
      this.queryParam = {
        type: this.queryParam.type,
        id: this.queryParam.id,
        factorCategory: "12",
        size: this.ipagination.pageSize,
        current: this.ipagination.current,
        stime: this.queryParam.stime,
        etime: this.queryParam.etime
      };

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      getAction('/st53/cn2011', this.queryParam).then(function (res) {
        if (res.success) {
          that.dataSource = res.result.records;
          that.ipagination.total = res.result.total;
          that.allColumns = _toConsumableArray(that.cols);
          that.selectCol = [];
          that.options = [];
          res.result.factorMap['12'].forEach(function (element) {
            that.options.push({
              label: element.title,
              value: element.code
            });
            that.selectCol.push(element.code);
            that.allColumns.push({
              id: element.code,
              title: element.title,
              align: 'center',
              width: 250,
              children: [{
                title: element.unitName,
                align: 'center',
                width: 200,
                dataIndex: element.code,
                customRender: function customRender(text, record, index) {
                  return that.renderCol(element.code, text, record);
                }
              }]
            });
          });
          that.columns = _toConsumableArray(that.allColumns);

          if (that.options.length > 16) {
            that.scroll = {
              x: 3000
            };
          } else {
            that.scroll = false;
          }

          if (that.queryParam.type == '1') {
            that.spliceColumn(that.siteColumn);
          } else if (that.queryParam.type == '2') {
            that.spliceColumn(that.siteColumn, 1);
          }
        } else {
          _this3.$message.warning('系统异常=>' + res.message);
        }

        _this3.loading = false;
      });
    },
    // 加载表格
    loadData2: function loadData2(selectSearch) {
      var _this4 = this;

      var that = this; // this.loading2 = true

      if (!selectSearch) {
        that.dataSource2 = [];
        that.allColumns2 = [];
        that.selectCol2 = [];
        that.options2 = [];
        return;
      }

      this.queryParam = {
        type: this.queryParam.type,
        id: this.queryParam.id,
        factorCode: selectSearch,
        size: this.ipagination2.pageSize,
        current: this.ipagination2.current,
        stime: this.queryParam.stime,
        etime: this.queryParam.etime
      };
      getAction('/st53/cn2011', this.queryParam).then(function (res) {
        if (res.success) {
          that.dataSource2 = res.result.records;
          that.ipagination2.total = res.result.total;
          that.allColumns2 = _toConsumableArray(that.cols2);
          that.selectCol2 = [];
          that.options2 = [];
          res.result.factorMap['13'].forEach(function (element) {
            that.options2.push({
              label: element.title,
              value: element.code
            });
            that.selectCol2.push(element.code);
            that.allColumns2.push({
              id: element.code,
              title: element.title,
              align: 'center',
              width: 250,
              children: [{
                title: element.unitName,
                align: 'center',
                width: 200,
                dataIndex: element.code,
                customRender: function customRender(text, record, index) {
                  return that.renderCol(element.code, text, record);
                }
              }]
            });
          });
          that.columns2 = _toConsumableArray(that.allColumns2);

          if (that.options2.length > 15) {
            that.scroll = {
              x: 3000
            };
          } else {
            that.scroll = false;
          }

          if (that.queryParam.type == '1') {
            that.spliceColumn2(that.siteColumn2);
          } else if (that.queryParam.type == '2') {
            that.spliceColumn2(that.siteColumn2, 1);
          }
        } else {
          _this4.$message.warning('系统异常=>' + res.message);
        }

        that.loading2 = false;
      });
    },
    getSearchData: function getSearchData(id) {
      var that = this;
      getAction('/st53/cn2011/electricity', {
        siteId: id || window.sessionStorage.getItem('siteId')
      }).then(function (res) {
        if (res.success) {
          that.searchData = res.result;

          if (res.result.length > 0) {
            that.selectSearch = res.result[0].code;
          } else {
            that.selectSearch = null;
          }

          that.loadData2(that.selectSearch);
        }
      });
    }
  }
};